export default interface MailingSettings {   
    isActive: boolean;
}

export const createNewMailingSettings = (): MailingSettings => {
    return {
        isActive: false        
    }
}